import { collection, doc, getDocs, setDoc, updateDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../firebase/firebaseConfig";
import { format, startOfMonth, endOfMonth, eachDayOfInterval, startOfWeek, endOfWeek, addDays, isSunday } from 'date-fns';
import { Link } from "react-router-dom";

const Serving = () => {
    const [currentMonth, setCurrentMonth] = useState(new Date());
  
    const handlePreviousMonth = async() => {
      setCurrentMonth(prev => new Date(prev.getFullYear(), prev.getMonth() - 1, 1));

      const previousMonth = getPreviousMonth(currentMonth);
      const querySnapshot = await getDocs(collection(db, "Serving/c9U8iHoqB4kgCfBaF0Fr/Teams"));
      const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      setData(documents);
      setActiveTeam(documents[0]);

      const querySnapshot2 = await getDocs(collection(db, `Serving/c9U8iHoqB4kgCfBaF0Fr/Teams/${documents[0].id}/${format(previousMonth,"MMMMyyyy")}`));
      const documents2 = querySnapshot2.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        for (let i = 0; i < documents2.length; i++) {
            if (documents2[i].id === 'Available') {
                documents2.splice(i, 1);
            }
        }

      setAllDuties(documents2);
    };

    const getPreviousMonth = (currentDate) => {
        return new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    };
  
    const handleNextMonth = async() => {
      setCurrentMonth(prev => new Date(prev.getFullYear(), prev.getMonth() + 1, 1));

      const nextMonth = getNextMonth(currentMonth);
      const querySnapshot = await getDocs(collection(db, "Serving/c9U8iHoqB4kgCfBaF0Fr/Teams"));
      const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      setData(documents);
      setActiveTeam(documents[0]);

      const querySnapshot2 = await getDocs(collection(db, `Serving/c9U8iHoqB4kgCfBaF0Fr/Teams/${documents[0].id}/${format(nextMonth,"MMMMyyyy")}`));
      const documents2 = querySnapshot2.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        for (let i = 0; i < documents2.length; i++) {
            if (documents2[i].id === 'Available') {
                documents2.splice(i, 1);
            }
        }

      setAllDuties(documents2);
    };

    const getNextMonth = (currentDate) => {
        return new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    };

    const [data, setData] = useState([]);
    const [activeTeam, setActiveTeam] = useState([]);
    const [allSundays, setAllSundays] = useState([]);
    const [allDuties, setAllDuties] = useState([]);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "Serving/c9U8iHoqB4kgCfBaF0Fr/Teams"));
                const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                setData(documents);
                setActiveTeam(documents[0]);

                const querySnapshot2 = await getDocs(collection(db, `Serving/c9U8iHoqB4kgCfBaF0Fr/Teams/${documents[0].id}/${format(currentMonth,"MMMMyyyy")}`));
                const documents2 = querySnapshot2.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                for (let i = 0; i < documents2.length; i++) {
                    if (documents2[i].id === 'Available') {
                        documents2.splice(i, 1);
                    }
                }

                setAllDuties(documents2);
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        };

        function getSundaysOfCurrentMonth() {
            const today = new Date();
            const start = startOfMonth(today);
            const end = endOfMonth(today);
        
            const days = eachDayOfInterval({ start, end });
        
            const sundays = days.filter((day) => isSunday(day));
        
            setAllSundays(sundays);
        }
    
        getSundaysOfCurrentMonth()
        fetchData();
    }, []);

    const currentDepartment = (e) => {
        for (let i = 0; i < data.length; i++) {
            if (e.target.value === data[i].Name) {
                setActiveTeam(data[i]);
            }
        }
    }

    const setAvailabilities = async (e) => {
        e.target.innerHTML = "Sending...";
        const querySnapshot = await getDocs(collection(db, "Members"));
        const documents = querySnapshot.docs.map(doc => ({ id: doc.id, Name: doc.data().Name, Surname: doc.data().Surname, ProfileImage: doc.data().ProfileImage}));

        console.log(documents)
        for (let i = 0; i < documents.length; i++) {
            await updateDoc(doc(db, `Serving/c9U8iHoqB4kgCfBaF0Fr/Teams/${activeTeam.id}/${format(currentMonth, "MMMMyyyy")}/Available`), {
                [documents[i].id]: documents[i]
            });
        }
        e.target.innerHTML = "Sent!";
    }

    return (
        <div id="content">
            <div className='row'>
                <h1>Serving</h1>
                <h2 className='ev-sub-title'>Revival Church Montana</h2>
            </div>
            <br/>
            <div className='row'>
                <div className='col-sm-6'>
                    <h3>{format(currentMonth, 'MMMM yyyy')}</h3>
                </div>
                <div className='col-sm-6 calendar-buttons'>
                    <div className='event-button'>
                        <button onClick={(e) => setAvailabilities(e)}>Availabilities Request</button>
                    </div>
                    <div className='navigate-buttons'>
                        <button onClick={handlePreviousMonth}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"/></svg>
                        </button>
                        <button onClick={handleNextMonth}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"/></svg>
                        </button>
                    </div>
                </div>
            </div>
            <br/>
            <div className='row'>
                <div className='col-sm-11'>
                <select id="team-select" onChange={(e) => currentDepartment(e)}>
                    {data.map(item => {
                        return <option value={item.Name}>{item.Name}</option>
                    })}
                </select>
                </div>
                <div className='col-sm-1'>
                    <Link to={`/${format(currentMonth, 'MMMMyyyy')}/${activeTeam.id}`}><button>Edit Duties</button></Link>
                </div>
            </div>
        </div>
    )
}

export default Serving; 